import React, { useState, useRef, useEffect } from 'react';

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

var _excluded = ["threshold", "height", "width", "style", "onVisible", "component", "children"];
var LazyLoad = function LazyLoad(_ref) {
  var _ref$threshold = _ref.threshold,
    threshold = _ref$threshold === void 0 ? 0.1 : _ref$threshold,
    height = _ref.height,
    width = _ref.width,
    style = _ref.style,
    onVisible = _ref.onVisible,
    component = _ref.component,
    children = _ref.children,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  var _useState = useState(false),
    load = _useState[0],
    setLoad = _useState[1];
  var ref = useRef();
  var styleProps = _extends({}, (height || width || style) && {
    style: _extends({
      height: height,
      width: width
    }, style)
  });
  useEffect(function () {
    var observer = new IntersectionObserver(function (_ref2) {
      var entry = _ref2[0];
      if (entry.isIntersecting) {
        observer.disconnect();
        onVisible === null || onVisible === void 0 ? void 0 : onVisible();
        setLoad(true);
      }
    }, {
      threshold: threshold
    });
    if (ref.current) {
      observer.observe(ref.current);
    }
    return function () {
      observer.disconnect();
    };
  }, [threshold]);
  return (
    /*#__PURE__*/
    React.createElement("div", _extends({}, styleProps, props, {
      ref: ref
    }), load ? component || children : null)
  );
};

export default LazyLoad;
//# sourceMappingURL=index.modern.js.map
